import clsx from 'clsx';

interface PaginationItemProps {
    active?: boolean;
    disabled?: boolean;
    content: JSX.Element | string;
    action: () => void;
}

const PaginationItem = ({action, content, disabled, active}: PaginationItemProps): JSX.Element => {
    return (
        <li
            className={clsx('page-item', {
                active: active,
                disabled: disabled,
            })}
        >
            <button className="page-link" onClick={() => action()}>
                {content}
            </button>
        </li>
    );
};

export default PaginationItem;
